export const RejectValue = {
    /** restoreSubscription */
    // 복원할 상태 없음
    RESTORE_REJECTED_BY_NO_PREV_STATE: 'RESTORE_REJECTED_BY_NO_PREV_STATE',
    // 복원할 상태가 현재와 일치
    RESTORE_REJECTED_BY_SAME_PREV_STATE: 'RESTORE_REJECTED_BY_SAME_PREV_STATE',
    // 사용자의 취소에 의한 복원 취소
    RESTORE_REJECTED_BY_USER_CANCEL: 'RESTORE_REJECTED_BY_USER_CANCEL',
    /** apply */
    // 신청 상태 조회중 오류 발생
    FETCH_APPLY_STATUS_REJECTED_DEFAULT: 'FETCH_APPLY_STATUS_REJECTED_DEFAULT',
    // 신청 중 오류 발생
    APPLY_REJECTED_DEFAULT: 'APPLY_REJECTED_DEFAULT',
    /** fetchDeliveryFee */
    // 배송비 재조회 요청 > 선택된 배송지 없음
    NO_SELECTED_ADDRESS: 'NO_SELECTED_ADDRESS',
}

export const START_SUBSCRIPTION_FALLBACK_MESSAGE = '일시적인 오류로 신청에 실패하였습니다. 잠시 후 다시 시도해주세요.'
